import _initializerDefineProperty from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/initializerDefineProperty";
import _classCallCheck from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/createClass";
import _defineProperty from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _applyDecoratedDescriptor from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/applyDecoratedDescriptor";

var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7;

import { makeObservable, observable, runInAction } from "mobx";
var OTAModel = (_class = /*#__PURE__*/function () {
  function OTAModel(platformUtil) {
    _classCallCheck(this, OTAModel);

    _initializerDefineProperty(this, "_isforcedUpdateFromCodePush", _descriptor, this);

    _initializerDefineProperty(this, "_isforcedUpdateFromVersionMismatch", _descriptor2, this);

    _initializerDefineProperty(this, "_codePushProgress", _descriptor3, this);

    _initializerDefineProperty(this, "_codePushUpdateMessage", _descriptor4, this);

    _initializerDefineProperty(this, "_codePushUpdateObject", _descriptor5, this);

    _initializerDefineProperty(this, "_codePushUpdateStatus", _descriptor6, this);

    _initializerDefineProperty(this, "_shouldRetryCodePushUpdate", _descriptor7, this);

    _defineProperty(this, "platformUtil", void 0);

    this.platformUtil = platformUtil;
    makeObservable(this);
  }

  _createClass(OTAModel, [{
    key: "isForcedUpdateFromCodePush",
    get: function get() {
      return this._isforcedUpdateFromCodePush;
    },
    set: function set(val) {
      var _this = this;

      runInAction(function () {
        _this._isforcedUpdateFromCodePush = val;
      });
    }
  }, {
    key: "isForcedUpdateFromVersionMismatch",
    get: function get() {
      return this._isforcedUpdateFromVersionMismatch;
    },
    set: function set(val) {
      var _this2 = this;

      runInAction(function () {
        _this2._isforcedUpdateFromVersionMismatch = val;
      });
    }
  }, {
    key: "currentApplicationVersionForForceUpdate",
    get: function get() {
      return this.platformUtil.getApplicationVersion();
    }
  }, {
    key: "codePushProgress",
    get: function get() {
      return this._codePushProgress;
    },
    set: function set(val) {
      var _this3 = this;

      runInAction(function () {
        _this3._codePushProgress = val;
      });
    }
  }, {
    key: "codePushUpdateMessage",
    get: function get() {
      return this._codePushUpdateMessage;
    },
    set: function set(val) {
      var _this4 = this;

      runInAction(function () {
        _this4._codePushUpdateMessage = val;
      });
    }
  }, {
    key: "codePushUpdateObject",
    get: function get() {
      return this._codePushUpdateObject;
    },
    set: function set(val) {
      var _this5 = this;

      runInAction(function () {
        _this5._codePushUpdateObject = val;
      });
    }
  }, {
    key: "codePushUpdateStatus",
    get: function get() {
      return this._codePushUpdateStatus;
    },
    set: function set(val) {
      var _this6 = this;

      runInAction(function () {
        _this6._codePushUpdateStatus = val;
      });
    }
  }, {
    key: "shouldRetryCodePushUpdate",
    get: function get() {
      return this._shouldRetryCodePushUpdate;
    },
    set: function set(val) {
      var _this7 = this;

      runInAction(function () {
        _this7._shouldRetryCodePushUpdate = val;
      });
    }
  }]);

  return OTAModel;
}(), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "_isforcedUpdateFromCodePush", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "_isforcedUpdateFromVersionMismatch", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "_codePushProgress", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "_codePushUpdateMessage", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "_codePushUpdateObject", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "_codePushUpdateStatus", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "_shouldRetryCodePushUpdate", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
})), _class);
export { OTAModel as default };